import React, { useEffect, useState } from "react";
import { FlatList, Image, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Button } from "../../button/Button";
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../utils";
import { Divider } from "../../divider/Divider";
const isFromMobileView = isMobile(getScreenType());
const PresentationMaterial = ({ presentationMaterial, triggerAction, downloadAction, loading, height }) => {
    const [allImages, setAllImages] = useState([]);
    const [presentationMaterialList, setPresentationMaterialList] = useState([]);
    const [selectedItem, setSelectedItem] = useState(0);
    const [imageData, setImageData] = useState([]);
    const [selectedBannerItem, setSelectedBannerItem] = useState(null);
    useEffect(() => {
        let presentationArray = [];
        const uniqueData = [];
        const allCategoryArray = [
            { category: "All" }
        ];
        presentationArray.push(...allCategoryArray);
        presentationMaterial.forEach(item => {
            const isDuplicate = uniqueData.some(i => i.category === item.category);
            if (!isDuplicate) {
                uniqueData.push(item);
            }
        });
        presentationArray.push(...presentationMaterial);
        setAllImages(presentationMaterial);
        uniqueData.unshift({
            file_url: "",
            category: "All",
            file_name: "",
            file_format: "",
            thumbnail_url: ""
        });
        setPresentationMaterialList(uniqueData);
    }, []);
    useEffect(() => {
        setImageData(allImages);
    }, [allImages]);
    const handleItemPress = (item, index) => {
        setSelectedItem(index);
        let indexArray = [];
        indexArray.push(item);
        const filteredData = presentationMaterial.filter(itemF => itemF.category === item.category);
        indexArray.push(item);
        if (item.category === "All") {
            setImageData(allImages);
        }
        else {
            setImageData(filteredData);
        }
    };
    const bannerTypeItem = (item, index) => {
        const isSelected = index === selectedItem;
        return (React.createElement(TouchableOpacity, { onPress: () => handleItemPress(item, index) },
            React.createElement(View, { style: isSelected ? styles.selectedBannerTypeItem : styles.bannerTypeItem },
                React.createElement(Typography, { label: item?.category, fontSize: FontSizeTokens.SM, fontWeight: "500", fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: isSelected ? ColorTokens.White : ColorTokens.Grey_Charcoal }))));
    };
    const bannerTypeItemSeparator = () => {
        return (React.createElement(View, { style: styles.bannerTypeItemSeparator }));
    };
    const collateralImageItemSeparator = () => {
        return (React.createElement(View, { style: styles.collateralImageItemSeparator }));
    };
    const collateralBannerImageList = () => {
        return (React.createElement(ScrollView, { style: { height: isFromMobileView ? height - 350 : height, paddingBottom: isFromMobileView && 200, marginLeft: isFromMobileView && 4 } },
            React.createElement(FlatList, { data: imageData, renderItem: (item) => collateralBanner(item), keyExtractor: (item) => item.id, showsHorizontalScrollIndicator: false, scrollEnabled: false, numColumns: isFromMobileView ? 1 : 4, nestedScrollEnabled: false, showsVerticalScrollIndicator: false, style: { height: height - 150, paddingBottom: 200 }, contentContainerStyle: { height: 500, paddingBottom: 200 }, ItemSeparatorComponent: collateralImageItemSeparator })));
    };
    const bannerTypeList = () => {
        return (React.createElement(FlatList, { data: presentationMaterialList, renderItem: ({ item, index }) => bannerTypeItem(item, index), keyExtractor: (item) => item.id, showsHorizontalScrollIndicator: false, horizontal: true, ItemSeparatorComponent: bannerTypeItemSeparator }));
    };
    const collateralBanner = (item) => {
        const imageUrl = item?.item.thumbnail_url !== undefined ? item?.item?.thumbnail_url : item?.item;
        return (React.createElement(View, { style: styles.presentationMaterialBanner },
            React.createElement(Image, { style: { height: 140 }, source: { uri: imageUrl }, resizeMode: 'stretch' }),
            React.createElement(Divider, { size: DividerSizeTokens.SM, height: 1, color: ColorTokens.Grey_Chalk }),
            React.createElement(View, { style: styles.presentationMaterialBottom },
                React.createElement(Typography, { label: item?.item.file_name, fontWeight: "600", fontSize: FontSizeTokens.SM, lineHeight: 20, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night }),
                React.createElement(Typography, { label: "PDF", fontWeight: "400", fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: styles.bottomCTA },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: "Download", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, customWidth: 148, loading: selectedBannerItem === item?.index && loading, onPress: () => {
                            setSelectedBannerItem(item?.index);
                            triggerAction({
                                ...downloadAction,
                                payload: {
                                    fileUrl: item?.item?.file_url,
                                    fileType: item.item?.file_format,
                                    fileName: item.item?.file_name,
                                    categoryName: item.item?.file_name
                                }
                            });
                        } })))));
    };
    return (React.createElement(ScrollView, { style: [styles.container, { height: height - 250 }], scrollEnabled: false, nestedScrollEnabled: false },
        bannerTypeList(),
        React.createElement(View, { style: { marginTop: 24 } }),
        collateralBannerImageList()));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        marginTop: 24
    },
    bodyContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 8
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    bannerTypeItem: {
        height: 32,
        borderRadius: 32,
        paddingVertical: 6,
        paddingHorizontal: 24,
        backgroundColor: "#F3F5FC",
        justifyContent: 'center',
        alignContent: 'center'
    },
    bannerTypeItemSeparator: {
        marginLeft: 12
    },
    presentationMaterialBanner: {
        marginTop: 24,
        marginLeft: !isFromMobileView ? 4 : 18,
        marginRight: 24,
        paddingBottom: 12,
        marginBottom: 24,
        flexDirection: 'column',
        height: 254,
        width: 304,
        borderWidth: 1,
        borderRadius: 4,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4,
        borderColor: '#F1F3F5',
        boxShadow: '0px 2px 5px rgba(9, 30, 66, 0.2)',
    },
    presentationMaterialBottom: {
        height: 110,
        position: 'absolute',
        bottom: 0,
        padding: 12,
        backgroundColor: 'white',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4
    },
    collateralImageItemSeparator: {
        marginLeft: 24
    },
    downloadCTA: {
        paddingBottom: 12
    },
    bottomCTA: {
        marginTop: 12,
        marginBottom: 16,
    },
    selectedBannerTypeItem: {
        height: 32,
        borderRadius: 32,
        paddingVertical: 6,
        paddingHorizontal: 24,
        backgroundColor: '#1434CB',
        justifyContent: 'center',
        alignContent: 'center'
    },
    presentationMobileBannerList: {
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
    }
});
// @ts-ignore
export default (PresentationMaterial);
